"use client";
import { FC } from "react";
import { BuilderProps } from "@/types/builder/BuilderProps";
import {
  SWDCInternalSearchTopFilter,
  TopFilterTab,
} from "@/components/InternalSearch";

type SWDCInternalSearchTopFilterBlockProps = {
  tabs?: TopFilterTab[];
} & BuilderProps;

export const SWDCInternalSearchTopFilterBlock: FC<
  SWDCInternalSearchTopFilterBlockProps
> = ({ tabs }) => {
  return <SWDCInternalSearchTopFilter tabs={tabs} />;
};
